import React from 'react';
import styles from './Home.module.scss';
import ProductTiles from '../ProductTiles/ProductTiles';
import { Row, Container } from 'react-bootstrap';
import TranslationService from '../../../core/services/TranslationService';

const Home = () => {
  return (
    <div className={styles.home}>
      <div className={styles['home__info-text']}>
        <Container>
          <Row className="justify-content-start">
            <section className="text-center">
                <h2>
                    {TranslationService.translate('AllToolsForManagingLabel')}
                </h2>
            </section>
          </Row>
        </Container>
      </div>
      <ProductTiles />
    </div>
  )
}

export default Home;